// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1echW","row":"styles_row__1RG55"};